// The courtroom's own moving things (world.json `fx`, recorded by frontend/art/r_courtroom.py): the court reporter's
// stenotype keys and its paper creeping out, and the press scribbling on their pads. Imported for its side effect by
// CourtroomStage. Pure functions of the clock, like every effect; under reduced motion they hold still.
import { registerFx } from './fx';

function px(ctx: CanvasRenderingContext2D, x: number, y: number, c: string, w = 1, h = 1): void {
  ctx.fillStyle = c;
  ctx.fillRect(Math.round(x), Math.round(y), w, h);
}

/** Bursts of typing: on for a few seconds, a breath, on again (the reporter keeps up with whoever is speaking). */
function typing(now: number, h: number): boolean {
  const period = 5200 + (h % 2600);
  return ((now + (h % 9973)) % period) / period < 0.72;
}

// The stenotype at (x, y): the machine's top row of keys, one pressed at a time while typing, and the paper fold
// stepping out of its back a pixel at a time.
registerFx('stenotype', (ctx, e, c, h) => {
  const on = c.animate && typing(c.now, h);
  const k = on ? Math.floor(c.now / 90 + h) % 7 : -1;
  for (let i = 0; i < 7; i += 1) px(ctx, e.x - 3 + i, e.y + 1, i === k ? '#fffbf2' : '#565068');
  const feed = c.animate ? Math.floor(c.now / 700) % 3 : 0;
  px(ctx, e.x + 4, e.y - 1 - feed, '#fffbf2', 3, 1 + feed);
}, 'air');

// A reporter's notepad at (x, y) beside the head, and the pen moving across it in bursts, then flipping a line.
registerFx('scribble', (ctx, e, c, h) => {
  px(ctx, e.x - 1, e.y - 1, '#160f1a', 6, 5);
  px(ctx, e.x, e.y, '#fffbf2', 4, 3);
  px(ctx, e.x, e.y + 1, '#c8c0b2', 3, 1);
  const period = 3400 + (h % 2200);
  const t = ((c.now + (h % 7919)) % period) / period;
  const writing = c.animate && t < 0.6;
  const dx = writing ? Math.floor(c.now / 140 + h) % 4 : 1;
  const dy = writing ? (Math.floor(c.now / 70 + h) % 2) : 0;
  px(ctx, e.x + dx, e.y - 1 + dy, '#1d2943');
  px(ctx, e.x + dx + 1, e.y - 2 + dy, '#c59b3c');
}, 'air');
